<template>
  <div class="dashboard-widget">
    <h6 class="text-primary">Monthly Stats</h6>
    <div class="md-layout stats-line">
      <div class="md-layout-item md-size-80 actions">
        <h6>No of Bookings: {{ bookings }}</h6>
      </div>
      <div class="md-layout-item md-size-20 actions text-right">
        <md-button
          :to="{ name: 'Booking Management' }"
          class="md-success md-just-icon md-simple action-button"
        >
          <md-icon>visibility</md-icon>
          <md-tooltip md-direction="top">View Bookings</md-tooltip>
        </md-button>
      </div>
    </div>

    <div class="md-layout stats-line">
      <div class="md-layout-item md-size-80 actions">
        <h6>No of Enquiries: {{ enquiries }}</h6>
      </div>
      <div class="md-layout-item md-size-20 actions text-right">
        <md-button
          :to="{ name: 'Enquiry Management' }"
          class="md-success md-just-icon md-simple action-button"
        >
          <md-icon>visibility</md-icon>
          <md-tooltip md-direction="top">View Enquiries</md-tooltip>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import enquiryApi from "@/services/api/enquiry";

export default {
  name: "WidgetMonthlyStats",
  data() {
    return {
      bookings: 0,
      enquiries: 0
    };
  },

  computed: {},

  methods: {},

  created() {
    bookingApi.getMonthlyBookingCount().then(response => {
      this.bookings = response.data.booking_count;
    });

    enquiryApi.getMonthlyEnquiryCount().then(response => {
      this.enquiries = response.data.enquiry_count;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.stats-line {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;

  h6 {
    margin: 0;
  }

  .actions {
    .action-button {
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin: 0px;
    }
  }
}
</style>
